import { Component, OnInit, Input, ElementRef, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { GameService } from '../../services/game.service';
import { GameGoodBad, GameGoodBadQuestion, GoodBadQuestionType, IGoodBadQuestionType } from '../../_models/model';
import { Router, ActivatedRoute } from '@angular/router';
import { AudioPlayerService } from '../../services/audio-player.service';
import { IGameComponent } from '../game/game.component';

type IAnswerType = 'good' | 'bad'

@Component({
    selector: 'app-game-good-bad',
    templateUrl: './game-good-bad.component.html',
    styleUrls: ['./game-good-bad.component.less']
})
export class GameGoodBadComponent implements OnInit, IGameComponent {
    @Output() closeEvent = new EventEmitter<boolean>();
    private activeGame?: GameGoodBad;
    private activeLevelId?: number;
    private activeQuestion?: GameGoodBadQuestion;

    // TODO: store progress data to send for levelProgress object
    private progressData = '';

    // Bindable properties
    public activeQuestionId = 0;
    public questionText?: string;
    public option?: IGoodBadQuestionType;
    public feedbackText?: string;
    public showFootnote = false;
    public showResults = false;
    public buttonCaption = this.audio.text.global.next;
    public showAnswers?: boolean;
    public showAnswersGoodButton?: boolean;
    public showAnswersBadButton?: boolean;

    // Used to indicate the progress
    public progressBarData:
    {
        id: number,
        correct: boolean;
        state: 'open' | 'good' | 'wrong';
    }[] = [];

    constructor(
        private gameService: GameService,
        private router: Router,
        private route: ActivatedRoute,
        public audio: AudioPlayerService,
        private _changeDetectionRef: ChangeDetectorRef) {
    }

    public setGame(game: GameGoodBad) {
        this.activeGame = game;
        this.activeQuestionId = 0;
        this.activeQuestion = game.questions[0];
        // Used to indicate the progress
        for (let questionId = 0; questionId < this.activeGame.questions.length; questionId++) {
            this.progressBarData.push({id: questionId, correct: false, state: 'open'});
        }
        this.showQuestion();
    }

    selectAnswer(answer: IGoodBadQuestionType) {
        this.audio.stop();

        if (answer !== this.activeQuestion?.type) {
            this.audio.playError();
            return;
        } else {
            this.audio.playSuccess();
        }
        // tslint:disable-next-line:triple-equals
        this.showAnswersGoodButton = answer === 'wrong';
        this.showAnswersBadButton = answer === 'good';
        const progressbarData = this.progressBarData.find(pd => pd.id === this.activeQuestionId);
        if(progressbarData) {
            progressbarData.state = 'good';
        }

        this.showAnswers = false;
        this.showFootnote = true;
        this.audio.playAudio(this.activeQuestion.feedback, () => {
            this.showResults = true;
        });
        setTimeout(() => {
          this.showResults = true;
        }, 1000);
    }

    setNextQuestion() {
      if (!this.activeGame) {
        throw Error('no active game found');
      }
        if (this.activeQuestionId + 1 >= this.activeGame.questions.length ) {
            this.gameService.setLevelProgress(this.activeGame.levelElement.uuid, this.progressData, true);
            this.closeEvent.emit();
            return;
        }
        this.activeQuestionId++;
        this.showFootnote = false;
        this.showResults = false;
        this.showQuestion();
    }


    showQuestion() {
      if (!this.activeGame) {
        throw Error('no active game found');
      }
        this.audio.stop();
        this.activeQuestion = this.activeGame.questions[this.activeQuestionId];
        this.questionText = this.activeQuestion.question.text;
        this.feedbackText = this.activeQuestion.feedback.text;
        this.option = this.activeQuestion.type;
        this.buttonCaption = this.audio.text.global.next;
        this.showFootnote = false;
        this.showResults = false;
        this.showAnswers = false;
        this.showAnswersGoodButton = true;
        this.showAnswersBadButton = true;
        this.audio.playAudio(this.activeQuestion.question, x => {
            this.showAnswers = true;
            this.showAnswersGoodButton = true;
            this.showAnswersBadButton = true;
        });
        setTimeout(() => {
            this.showAnswers = true;
            this.showAnswersGoodButton = true;
            this.showAnswersBadButton = true;
        },1000 );
        // tslint:disable-next-line:max-line-length
        // See https://blog.angularindepth.com/everything-you-need-to-know-about-the-expressionchangedafterithasbeencheckederror-error-e3fd9ce7dbb4
        this._changeDetectionRef.detectChanges();
    }

    ngOnInit(): void {

    }
}
